var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"editorArea",staticClass:"editor-area"},[_c('div',{ref:"blocklyDiv",attrs:{"id":"blocklyDiv"}})])}
var staticRenderFns = []

export { render, staticRenderFns }